<cdx-slotted-modal
  center="true"
  size="medium"
  (close)="closeModal()"
  *ngIf="preferences$ | async as templatePreferences"
>
  <h1
    modal-header
    i18n="@@changeOrderConfirmation-alreadyChangingOrderHeading"
    class="heading--2"
  >
    Modify your preferences
  </h1>

  <div modal-content>

    <h2 class="heading--4">Household</h2>
    <recipe-meal-plan-household-preference
      [adultValue]="templatePreferences[preferenceName.people].adult"
      [childValue]="templatePreferences[preferenceName.people].child"
      (increment)="saveHouseholdPreference($event, templatePreferences)"
      (decrement)="saveHouseholdPreference($event, templatePreferences)"
    ></recipe-meal-plan-household-preference>  

    <h2 class="heading--4">Dietary</h2>
    <recipe-meal-plan-dietary-preference
			[value]="templatePreferences[preferenceName.dietaryNeeds][0]"
			[options]="dietaryOptions"
			(valueChange)="saveDietaryPreference($event, templatePreferences)"
		></recipe-meal-plan-dietary-preference>
  </div>

  <div class="footer-slot" modal-footer-primary>
    <ng-container *ngTemplateOutlet="(isMobileDevice$ | async) ? primaryButton : secondaryButton"></ng-container>
		<ng-container *ngTemplateOutlet="(isMobileDevice$ | async) ? secondaryButton : primaryButton"></ng-container>
	
		<ng-template #secondaryButton>
			<button
        fillStyle="flat"
        cdxButton
        (click)="reset()"
        i18n="@@changeOrderConfirmation-continueShoppingButton"
        size="medium"
        data-cy="resetButton"
      >
        Reset
      </button>
		</ng-template>

		<ng-template #primaryButton>
      <button
        cdxButton
        (click)="applyChanges(templatePreferences)"
        i18n="@@changeOrderConfirmation-continueShoppingButton"
        size="medium"
        data-cy="applyButton"
      >
        Apply
      </button>
		</ng-template> 

  </div>
</cdx-slotted-modal>